import React from "react";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { validate, validators } from "validate-redux-form";
import { renderField, renderCurrency } from "../../Utils/renderField";

const CrearEditarForm = (props) => {
    const { handleSubmit } = props;

    return (
        <form
            name="CrearEditarForm"
            className="form-validate mb-lg"
            onSubmit={handleSubmit}
        >
            <div className="row w-70">
                <div className="form-group has-feedback col-12">
                    <label htmlFor="nombre">Nombre</label>
                    <Field
                        name="nombre"
                        label="Nombre"
                        component={renderField}
                        type="text"
                        className="input--style"
                        placeholder="Nombre..."
                    />
                </div>
            </div>
            <div className="row w-70">
                <div className="form-group has-feedback col-12">
                    <label htmlFor="fase">Monto (USD)</label>
                    <Field
                        name="monto"
                        label="Monto (USD)"
                        component={renderCurrency}
                        className="form-control"
                        placeholder="Monto..."
                        prefix="$"
                    />
                </div>
            </div>
            <div className="buttons-box">
                <Link
                    to="/gastos_administrativos"
                    className="btn"
                    style={{ fontSize: 15 }}
                >
                    Cancelar
                </Link>
                <button
                    type="submit"
                    style={{ fontSize: 15 }}
                    className="btn btn-primary m-1 align-self-center"
                >
                    Guardar
                </button>
            </div>
        </form>
    );
};

export default reduxForm({
    form: "CrearEditarForm", // a unique identifier for this form
    validate: (data) => {
        return validate(data, {
            nombre: validators.exists()("Este campo es requerido"),
            monto: validators.number({ min: 0 })(
                "Valor mayor o igual a 0 requerido"
            ),
        });
    },
})(CrearEditarForm);
